var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { borderRadius, colors, type } from '@workday/canvas-kit-react/tokens';
import { styled, createComponent } from '@workday/canvas-kit-react/common';
var variantStyles = {
    inverse: {
        color: colors.frenchVanilla100,
        '&:hover': {
            color: colors.frenchVanilla100,
            background: 'rgba(255, 255, 255, 0.1)',
        },
        '&:focus': {
            boxShadow: "0 0 0 2px " + colors.frenchVanilla100,
        },
        '&:active': {
            color: colors.blueberry600,
            background: colors.soap200,
        },
    },
};
var anchorVariants = function (props) {
    if (props.variant === 'inverse') {
        return variantStyles.inverse;
    }
    return {};
};
var Anchor = styled('a')({
    fontFamily: type.properties.fontFamilies.default,
    textDecoration: 'underline',
    color: colors.blueberry400,
    cursor: 'pointer',
    borderRadius: borderRadius.s,
    display: 'inline-block',
    padding: '0 2px',
    margin: '0 -2px',
    transition: 'color 0.15s,background-color 0.15s',
    '&:hover': {
        color: colors.blueberry500,
        background: colors.soap200,
    },
    '&:focus': {
        boxShadow: "0 0 0 2px " + colors.blueberry400,
        outline: 'none',
    },
    '&:active': {
        color: colors.blueberry600,
        background: colors.soap300,
    },
}, anchorVariants);
export var Hyperlink = createComponent('a')({
    displayName: 'Hyperlink',
    Component: function (_a, ref, Element) {
        var variant = _a.variant, href = _a.href, children = _a.children, elemProps = __rest(_a, ["variant", "href", "children"]);
        return (React.createElement(Anchor, __assign({ ref: ref, as: Element, variant: variant, href: href }, elemProps), children));
    },
});
